import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/setting';

/**
 * TITA 扩展：出演监管
 * 菜单 route：/perform
 */
const performRouter: RouteRecordRaw = {
  path: `${roterPre}/perform`,
  name: 'Perform',
  component: Layout,
  meta: {
    title: '出演监管',
    icon: 's-opportunity',
  },
  children: [
    {
      path: '',
      name: 'PerformLst',
      meta: {
        title: '出演监管',
        noCache: true,
      },
      component: () => import('@/views/_expand/perform/index.vue'),
    },
  ],
};

export default performRouter;
